<template>
  <div class="privacy has-background-white-bis fixspace">
    <section class="hero is-medium">
      <div class="hero-body pb-5">
        <div class="container is-max-desktop pb-6">
          <div class="columns">
            <div class="column is-four-fifths is-offset-1">
              <h1 class="title is-4">
                {{ $t('privacy.privacy') }}
              </h1>
              <p class="is-size-7 py-6 termstext-h">
                Musian (“Musian”, “we”, “us” or “our”) is committed to protecting the privacy of
                personal information (i.e. any information relating to an identified or
                identifiable natural person) who visit the https://musian.app website and Musian
                mobile software application (collectively, the “Site”) and use the services
                available thereon (the “Services”). Amendments to this Privacy Policy will be
                posted to the Site and/or Services and will be effective when posted. Your
                continued use of the Site and/or Services following the posting of any amendment
                to this Privacy Policy shall constitute your acceptance of such amendment.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section">
      <div class="container is-max-desktop pb-6">
        <div class="columns">
          <div class="column is-four-fifths is-offset-1">
            <hr class="my-6"
                style="border-top:1px solid #000 !important; height:1px !important; width:20px;">
            <p class="is-size-6 has-text-weight-semibold has-text-black mb-3">
              Consent and Information Collection and Use
            </p>
            <p class="is-size-7 py-2 termstext-h">
              When you register as a user of our Site and Services, we ask for personal
              information that will be used to activate your account, provide the Services to
              you, communicate with you about the status of your account, and for other
              purposes set out in this Privacy Policy. Your name, company name, address,
              telephone number, email address, information and certain other
              information about you may be required by us to provide the Services or be
              disclosed by you during your use of the Services. You will also be asked to
              create a user name and private password, which will become part of your account
              information.
            </p>
            <p class="is-size-7 py-2 termstext-h">
              By providing personal information to us and by retaining us to provide you with
              the Services, you voluntarily consent to the collection, use and disclosure of
              such personal information as specified in this Privacy Policy. The legal bases
              for our processing of personal information are primarily that the processing is
              necessary for providing the Services and that the processing is carried out in
              our legitimate interests, which are further explained below. Without limiting
              the foregoing, we may on occasion ask you to consent when we collect, use, or
              disclose your personal information in specific circumstances.
            </p>
            <p class="is-size-7 py-2 termstext-h">
              We take steps designed to ensure that only those employees who need access to
              your personal information to fulfil their employment duties will have access
              to it. We may use and disclose your personal or account information for the
              following purposes:
            </p>
            <div class="content">
            <ul class="is-size-7 termstext-h">
              <li class="py-1">To provide the Site and Services to you and to other users of
                the Site and Services;</li>
              <li class="py-1">To improve the quality of the Site and Services through polls,
                surveys and other similar feedback gathering activities conducted by Musian
                and/or third parties;</li>
              <li class="py-1">To create, manage and control your account information, and
                to verify access rights to the Site and Services;</li>
              <li class="py-1">To bill your account;</li>
              <li class="py-1">To communicate with you (subject to your opt-out rights set
                forth in this Privacy Policy), including without limitation for the purpose
                of providing you with information about the Services, or informing you of
                changes or additions to the Services or of the availability of any other
                services or features we provide;</li>
              <li class="py-1">To assess service levels, monitor traffic patterns and gauge
                popularity of different features and service options of the Site and/or
                Services;</li>
              <li class="py-1">To enforce this Privacy Policy or our Terms of Service;</li>
              <li class="py-1">To protect against fraud or error, and to respond to claims
                of any violation of our rights or those of any third parties;</li>
              <li class="py-1">To respond to your requests for customer service;</li>
              <li class="py-1">To protect the rights, property or personal safety of you,
                us, our users and the public; and</li>
              <li class="py-1">As required to comply with applicable laws or as authorized
                by applicable laws.</li>
            </ul>
            <p class="is-size-7 py-2 termstext-h">
              Musian may share your personal information with its registered API application
              providers, including Chrome tab extensions Panda and Muz.li which deliver
              relevant design stories and inspiration. We invite you to review their
              applicable data protection policies.
            </p>
            <p class="is-size-7 py-2 termstext-h">
              When we disclose your personal information to third parties, we take reasonable
              measures to ensure that the rules set forth in this Privacy Policy are complied
              with and these third parties provide sufficient guarantees to implement
              appropriate technical and organisational measures.
            </p>
            <p class="is-size-7 py-2 termstext-h">
              Your personal information may be stored and processed in any country where we
              have facilities or in which we engage third party service providers. By using
              the Services, you consent to the transfer of information to countries outside
              your country of residence, which may have different data protection rules
              than in your country. While such information is outside of Canada, it is
              subject to the laws of the country in which it is held, and may be subject
              to disclosure to the governments, courts or law enforcement or regulatory
              agencies of such other country, pursuant to the laws of such country.
              However, our practices regarding your personal information will at all times
              continue to be governed by this Privacy Policy and, if applicable, we will
              comply with the General Data Protection Regulation (“GDPR”) requirements
              providing adequate protection for the transfer of personal information from
              the EU/EEA to third country.
            </p>
            <p class="is-size-7 py-2 termstext-h">
              We may occasionally communicate with you regarding our products, services,
              news and events. You have the option to not receive this information. We
              provide an opt-out function within all email communications of this nature,
              or will cease to communicate with you for this purpose if you contact us and
              tell us not to communicate this information to you. The only kind of these
              communications that you may not “opt-out” of are those required to
              communicate announcements related to the Services, including information
              specific to your Account, planned Services suspensions and outages. We will
              attempt to minimize this type of communication to you.
            </p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section py-5">
      <div class="container is-max-desktop pb-6">
        <div class="columns">
          <div class="column is-four-fifths is-offset-1">
            <hr class="my-6"
                style="border-top:1px solid #000 !important; height:1px !important; width:20px;">
            <p class="is-size-6 has-text-weight-semibold has-text-black mb-3">
              Age of Consent
            </p>
            <p class="is-size-7 py-2 termstext-h">
              We do not knowingly provide the Services to, and will not knowingly collect the
              personal information from anyone under the age of consent. If you live in a
              country in the EU/EEA, you must be at least 16 years old to use our Services or
              such greater age required in your country to register for or use our Services.
              If you live in any other country except those in the EU/EEA, you must be at least
              13 years old to use our Services or such greater age required in your country to
              register for or use our Services. In addition to being of the minimum required age
              to use our Services under applicable law, if you are not old enough to have
              authority to agree to our Privacy Policy in your country, your parent or guardian
              must agree to our Privacy Policy on your behalf. If you have any concerns about
              your child’s personal information, please contact us at contact@musian.com.
            </p>
            <p class="is-size-7 py-2 termstext-h">
              Neither the Site nor the Services are intended for children under 13 years of age,
              and no one under age 13 may provide any personal information to, on or through
              the Site or Services. We do not knowingly collect personal information from
              children under 13. If you are under 13, do not use or provide any information to,
              on or through the Site or Services, make any purchases through the Site or
              Services, use any of the interactive or public comment features, or provide any
              information about yourself to us, including your name, address, telephone number,
              email address, or any screen name or user name you may use. If we learn we have
              collected or received personal information from a child under 13 without
              verification of parental consent, we will delete that information. If you believe
              we might have any information from or about a child under 13, please contact us at
              the email address provided in the paragraph above.
            </p>
          </div>
        </div>
      </div>
    </section>

    <section class="section py-5">
      <div class="container is-max-desktop pb-6">
        <div class="columns">
          <div class="column is-four-fifths is-offset-1">
            <hr class="my-6"
                style="border-top:1px solid #000 !important; height:1px !important; width:20px;">
            <p class="is-size-6 has-text-weight-semibold has-text-black mb-3">
              Rights to Your Information
            </p>
            <p class="is-size-7 py-2 termstext-h">
              You have the right to access and edit your information at any time through the web
              interface provided as part of the Services. On written request and subject to proof
              of identity, you may access the personal information that we hold, used or
              communicated and ask that any necessary corrections be made, where applicable, as
              authorized or required by law. However, to make sure that the personal information
              we maintain about you is accurate and up to date, please inform us immediately of
              any change in your personal information by mail or e-mail.
            </p>
            <p class="is-size-7 py-2 termstext-h">
              Under the GDPR, you may be entitled to additional rights, including: (i) the right
              to withdraw consent to processing where consent is the basis of processing; (ii)
              the right to access your personal information and certain other supplementary
              information, under certain conditions; (iii) the right to object to unlawful data
              processing, under certain conditions; (iv) the right to erasure of personal
              information about you, under certain conditions; (v) the right to demand that we
              restrict processing of your personal information, under certain conditions, if you
              believe we have exceeded the legitimate basis for processing, processing is no longer
              necessary, are processing, or believe your personal information is inaccurate; (vi)
              the right to data portability of personal information concerning you that you provided
              us in a structured, commonly used, and machine-readable format, under certain
              conditions; (vii) the right object to decisions being taken by automated means which
              produce legal effects concerning you or similarly significantly affect you, under
              certain conditions; (viii) the right to lodge a complaint with data protection
              authorities. If you want to learn more about your rights under the GDPR, you can
              visit the European Commission’s page on Data Protection.
            </p>
          </div>
        </div>
      </div>
    </section>

    <section class="section py-5">
      <div class="container is-max-desktop pb-6">
        <div class="columns">
          <div class="column is-four-fifths is-offset-1">
            <hr class="my-6"
                style="border-top:1px solid #000 !important; height:1px !important; width:20px;">
            <p class="is-size-6 has-text-weight-semibold has-text-black mb-3">
              Aggregated Data
            </p>
            <p class="is-size-7 py-2 termstext-h">
              We may also use your personal information to generate Aggregated Data for internal
              use and for sharing with others on a selective basis. “Aggregated Data” means
              records which have been stripped of information potentially identifying users,
              and which have been manipulated or combined to provide generalized, anonymous
              information. Your identity and personal information will be kept anonymous in
              Aggregated Data.
            </p>
          </div>
        </div>
      </div>
    </section>

    <section class="section py-5">
      <div class="container is-max-desktop pb-6">
        <div class="columns">
          <div class="column is-four-fifths is-offset-1">
            <hr class="my-6"
                style="border-top:1px solid #000 !important; height:1px !important; width:20px;">
            <p class="is-size-6 has-text-weight-semibold has-text-black mb-3">
              Links
            </p>
            <p class="is-size-7 py-2 termstext-h">
              The Site and/or Services may contain links to other sites and we are not responsible
              for the privacy practices or the content of such sites. We encourage you to read
              the privacy policy of linked sites. Their privacy policies and practices differ
              from our policies and practices.
            </p>
          </div>
        </div>
      </div>
    </section>

    <section class="section py-5">
      <div class="container is-max-desktop pb-6">
        <div class="columns">
          <div class="column is-four-fifths is-offset-1">
            <hr class="my-6"
                style="border-top:1px solid #000 !important; height:1px !important; width:20px;">
            <p class="is-size-6 has-text-weight-semibold has-text-black mb-3">
              Cookies and Log Files
            </p>
            <p class="is-size-7 py-2 termstext-h">
              We use cookies and log files to track user information. Cookies are small amounts
              of data that are transferred to your web browser by a web server and are stored on
              your computer’s hard drive. We use cookies to track which page variant a visitor
              has seen, to track if a visitor has clicked on a page variant, to monitor traffic
              patterns and to gauge popularity of service options. We will use this information
              to deliver relevant content and services to you.
            </p>
          </div>
        </div>
      </div>
    </section>

    <section class="section py-5">
      <div class="container is-max-desktop pb-6">
        <div class="columns">
          <div class="column is-four-fifths is-offset-1">
            <hr class="my-6"
                style="border-top:1px solid #000 !important; height:1px !important; width:20px;">
            <p class="is-size-6 has-text-weight-semibold has-text-black mb-3">
              Third Parties’ & Interest-Based Ads
            </p>
            <p class="is-size-7 py-2 termstext-h">
              We do not control third parties’ collection or use of your information to serve
              interest-based advertising. However, these third parties may provide you with ways
              to choose not to have your information collected or used in this way. You can opt
              out of receiving targeted ads from members of the Network Advertising Initiative
              (“NAI”) on the NAI’s website.
            </p>
          </div>
        </div>
      </div>
    </section>

    <section class="section py-5">
      <div class="container is-max-desktop pb-6">
        <div class="columns">
          <div class="column is-four-fifths is-offset-1">
            <hr class="my-6"
                style="border-top:1px solid #000 !important; height:1px !important; width:20px;">
            <p class="is-size-6 has-text-weight-semibold has-text-black mb-3">
              Change of Ownership or Business Transition
            </p>
            <p class="is-size-7 py-2 termstext-h">
              In the event of a change of ownership or other business transition, such as a merger,
              acquisition or sale of our assets, your information may be transferred in accordance
              with applicable privacy laws.
            </p>
          </div>
        </div>
      </div>
    </section>

    <section class="section py-5">
      <div class="container is-max-desktop pb-6">
        <div class="columns">
          <div class="column is-four-fifths is-offset-1">
            <hr class="my-6"
                style="border-top:1px solid #000 !important; height:1px !important; width:20px;">
            <p class="is-size-6 has-text-weight-semibold has-text-black mb-3">
              Security and Retention
            </p>
            <p class="is-size-7 py-2 termstext-h">
              We will strive to prevent unauthorized access to your personal information, however,
              no data transmission over the Internet, by wireless device or over the air is
              guaranteed to be 100% secure. We have implemented and maintain reasonable security
              procedures and practices (based on the nature of the information we collect) to
              protect that information from unauthorized disclosure. We will continue to enhance
              security procedures as new technologies and procedures become available.
            </p>
            <p class="is-size-7 py-2 termstext-h">
              We strongly recommend that you do not disclose your password to anyone.
            </p>
            <p class="is-size-7 py-2 termstext-h">
              Please remember that you control what personal information you provide while using
              the Site and Services. Ultimately, you are responsible for maintaining the secrecy
              of your identification, passwords and/or any personal information in your possession
              for the use of the Site and/or Services. Always be careful and responsible regarding
              your personal information. We are not responsible for, and cannot control, the use by
              others of any information which you provide to them and you should use caution in
              selecting the personal information you provide to others through the Site or
              Services. Similarly, we cannot assume any responsibility for the content of any
              personal information or other information which you receive from other users through
              the Site or Services, and you release us from any and all liability in connection
              with the contents of any personal information or other information which you may
              receive using the Site or Services. We cannot guarantee, or assume any responsibility
              for verifying, the accuracy of the personal information or other information
              provided by any third party. You release us from any and all liability in connection
              with the use of such personal information or other information of others.
            </p>
            <p class="is-size-7 py-2 termstext-h">
              We will maintain your personal information for as long as they are needed, or as
              required by applicable laws, regulations, or government orders.

            </p>
          </div>
        </div>
      </div>
    </section>

    <section class="section py-5">
      <div class="container is-max-desktop pb-6">
        <div class="columns">
          <div class="column is-four-fifths is-offset-1">
            <hr class="my-6"
                style="border-top:1px solid #000 !important; height:1px !important; width:20px;">
            <p class="is-size-6 has-text-weight-semibold has-text-black mb-3">
              Changes to this Policy
            </p>
            <p class="is-size-7 py-2 termstext-h">
              We may update this Privacy Policy from time to time. If we do so, we will send an
              email to users subscribed to the Company News list. We will also add a site banner
              alerting users who may not be subscribed. If the change materially effects the
              treatment of your personal data, and we have your email but you are not subscribed
              to the Company News list, we will send you an email. (You are responsible for
              ensuring that we have an up-to-date email for this purpose.)
            </p>
          </div>
        </div>
      </div>
    </section>

    <section class="section py-5">
      <div class="container is-max-desktop pb-6">
        <div class="columns">
          <div class="column is-four-fifths is-offset-1">
            <hr class="my-6"
                style="border-top:1px solid #000 !important; height:1px !important; width:20px;">
            <p class="is-size-6 has-text-weight-semibold has-text-black mb-3">
              Contact Us
            </p>
            <p class="is-size-7 py-2 termstext-h">
              You may contact Musian please submit ticket at Help Center
            </p>
          </div>
        </div>
      </div>
    </section>

    <section class="section">
      <div class="container is-max-desktop pb-6">
        <div class="columns">
          <div class="column is-four-fifths is-offset-1">
            <hr>
            <p class="is-size-7 has-text-weight-semibold">Updated Febuary 17, 2020</p>
          </div>
        </div>
      </div>
    </section>

  </div>
</template>

<script>

export default {
  name: 'Privacy',

  metaInfo() {
    return {
      title: this.$t('title.privacy'),
      meta: [
        { property: 'og:title', vmid: 'og:title', content: this.$t('title.privacy') },
      ],
    };
  },

  computed: {

  },

  mounted() {
    this.forGtag();
  },

  beforeDestroy() {
    clearTimeout(this.timer);
  },

  methods: {
    forGtag() {
      this.timers = setTimeout(() => {
        this.$emit('forGtagStatus', this.$t('title.privacy'));
      }, 500);
    },
  },
};
</script>

<style lang="scss">
.termstext-h {
   line-height: 25px;
}
</style>
